import Box from '@mui/material/Box';
import TableCell from '@mui/material/TableCell';
import React from 'react';

import { useStyles } from '../DataTable.styles';
import type { DataTableCellShell, SortDirection } from '../DataTable.types';
import { ResizeHandle } from './resize-handle/ResizeHandle';
import { SortableHeaderLabel } from './sortable-header-label/SortableHeaderLabel';

export interface DataTableHeaderCellProps {
    shell: DataTableCellShell;
    isSortActive: boolean;
    sortDirection: SortDirection;
    onSort: (field: string) => void;
}

const DataTableHeaderCellInner = ({
    shell,
    isSortActive,
    sortDirection,
    onSort,
}: DataTableHeaderCellProps) => {
    const { classes, cx } = useStyles();
    const { column } = shell;
    return (
        <TableCell
            className={cx(classes.cell, classes.headerCell, shell.isFirst && classes.cellFirst)}
            style={{ width: shell.width }}
        >
            <Box>
                {column.sortable === false ? (
                    column.headerName
                ) : (
                    <SortableHeaderLabel
                        text={column.headerName}
                        active={isSortActive}
                        direction={sortDirection}
                        onSort={() => onSort(column.field)}
                    />
                )}
            </Box>
            <ResizeHandle shell={shell} automationId />
        </TableCell>
    );
};

export const DataTableHeaderCell = React.memo(DataTableHeaderCellInner);
